import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { tabVisible } from '@platform/plugin-platform-react';

/**
 * L'onglet « Observabilité » des charges de travail déployées.
 *
 * Il n'existait qu'à un seul endroit — la colonne vertébrale
 * (`entityRoutes.tsx`) — contrairement à « Sécurité » qui en avait deux. Le
 * filtre reprend donc exactement son périmètre : les composants.
 */
const isComponent = (entity: Entity): boolean =>
  entity.kind?.toLowerCase() === 'component';

const monitoringContent = EntityContentBlueprint.make({
  name: 'monitoring',
  params: {
    path: '/monitoring',
    title: 'Logs & métriques',
    filter: tabVisible('monitoring', isComponent),
    loader: () =>
      import('./MonitoringContent').then(m => <m.MonitoringContent />),
  },
});

export default createFrontendPlugin({
  pluginId: 'monitoring',
  extensions: [monitoringContent],
});
